import { State } from '../../../reducers';
import { createSelector } from '@ngrx/store';
import { VideoHotspot } from 'brain-data/model/config.model';

export const selectConfigData = (state: State) => state.config;

export const selectTenantConfig = createSelector(selectConfigData, configState => configState.tenantConfig);

export const selectTenantConfigError = createSelector(selectConfigData, configState => configState.tenantError);

export const selectVideoHotspots = createSelector(
  selectTenantConfig,
  (tenantConfig): VideoHotspot[] => tenantConfig?.data?.videoHotspots ?? [],
);

export const selectVideoHotspotsMap = createSelector(
  selectVideoHotspots,
  (hotspots): Map<string, VideoHotspot> => new Map(hotspots.map(h => [h.id, h])),
);
